var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "switch-box" },
    [
      _vm._l(_vm.tabList, function (item, index) {
        return [
          _c(
            "div",
            {
              key: item.value,
              staticClass: "btn",
              class: { active: index === _vm.currentIndex },
              on: {
                click: function ($event) {
                  return _vm.tabItemClick({ item, index })
                },
              },
            },
            [_vm._v(" " + _vm._s(item.label) + " ")]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }